
import { Vue, Component, Watch } from "vue-property-decorator";
import { api_store, store } from "@/http/store";
import PageHeader from "@/components/pageHeader/index.vue";
import { ElForm } from "element-ui/types/form";
import Upimg from "@/components/storeupimg/index.vue";
import Map from "@/components/map/index.vue";
import { api_user, user } from "@/http/user";
import { api_region } from "@/http/region";
import {
  provinceAndCityData,
  pcTextArr,
  regionData,
  pcaTextArr,
  codeToText,
} from "element-china-area-data";
@Component({
  components: {
    PageHeader,
    Upimg,
    Map,
  },
})
export default class extends Vue {
  info: store = {
    id: "",
    name: "",
    cover: "",
    // province:codeToText(this.pcaTextArr[0]),
    // city: codeToText(this.pcaTextArr[1]),
    // region: codeToText(this.pcaTextArr[2]),
    province: "",
    city: "",
    region: "",
    address: "",
    phone: "",
    merch_id: "",
    device: "",
    user: 1,
    status: 1,
    longitude: "",
    latitude: "",
    number: 1,
    create_time: "",
    update_time: "",
    wx_amount: 0,
    dy_amount: 0,
    commission_ratio: 0,
    account: "",
    password: "",
    user_level: "0",
    region_id: ""
  };
  coverUrls: string[] = [];
  pcaTextArr = pcaTextArr;
  selectedOptions: string[] = [];
  baseRules = {
    name: [{ required: true, message: "请输入" }],
    cover: [{ required: true, message: "请上传封面" }],
    // regionData: [{ required: true, message: "请选择省市" }],
    address: [{ required: true, message: "请填写具体位置" }],
    region_id: [{ required: true, message: "请选择所属区域" }],
    phone: [{ required: true, message: "请填写联系电话" }],
    device: [{ required: true, message: "请填写设备编号" }],
    number: [{ required: true, message: "请填写设备格子数" }],
    // wx_amount: [{ required: true, message: "请填写微信分佣金额" }],
    // dy_amount: [{ required: true, message: "请填写抖音分佣金额" }],
    commission_ratio: [{ required: true, message: "请填写分佣比例" }],
    account: [
      { required: true, message: "请填写门店后台账号" },
      {
        validator: (rule:any, value:any, callback:any) => {
          const phoneNumberRegex = /^1[3-9]\d{9}(-[1-9])?$/;
          if (!value || phoneNumberRegex.test(value)) {
            callback();
          } else {
            callback(new Error("手机号格式不正确"));
          }
        },
        trigger: "blur",
      },
    ],
    password: [{ required: true, message: "请填写门店后台密码" }],
  };
  generateRules(isEdit: boolean) {
    const rulesCopy = { ...this.baseRules }; // 创建 baseRules 的浅拷贝
    console.log(rulesCopy);
    if (isEdit) {
      // 在编辑模式下，清除 password 字段的验证规则
      (rulesCopy as { password?: any }).password = undefined;
      delete (rulesCopy as { password?: any }).password;
    }

    return rulesCopy;
  }

  //选择的省市区数据
  addressChange() {
    this.info.province = this.selectedOptions[0];
    this.info.city = this.selectedOptions[1];
    this.info.region = this.selectedOptions[2];
  }
  // 地图数据
  key = false;
  sendData({ name, gpsX, gpsY }: any) {
    this.info.longitude = gpsX;
    this.info.latitude = gpsY;
    this.key = false;
  }
  async submit() {
    // 校验是否选择了绑定用户
    if (!this.selectedUser) {
      this.$message.error("请选择绑定用户");
      return;
    }
    
    await (this.$refs["form"] as ElForm | undefined)?.validate();
    if (this.id) {
      await api_store.edit(this.info);
    } else {
      await api_store.create(this.info);
    }
    // this.$message.success("提交成功");
    this.$router.go(-1);
  }

  async get_info() {
    this.info = await api_store.get_info(this.id as number);
    // 处理封面图
    if (typeof this.info.cover === "string") {
      //const domain = "https://images.xiyuebiaoju.com/";
      const domain = "";
      this.coverUrls = this.info.cover
        .split(",")
        .map((url) => domain + url.trim());
    }

    // 处理三级联动
    const { province, city, region } = this.info;
    this.selectedOptions = [province, city, region];
    
    // 处理用户选择显示
    if (this.info.user) {
      try {
        const userInfo = await api_user.get_info(this.info.user);
        this.selectedUser = userInfo;
        this.userSearchText = `${userInfo.nickname} (${userInfo.phone})`;
      } catch (error) {
        console.error('获取用户信息失败:', error);
      }
    }
  }
  // 监听图片数据
  @Watch("coverUrls")
  setCover(val: string[]) {
    //const domain = "https://images.xiyuebiaoju.com/";
    const domain = "";
    this.info.cover = val.map((url) => url.replace(domain, "")).join(", ");
  }
  get id(): undefined | number {
    return this.$route.query.id as any;
  }
  // 用户搜索相关
  userSearchText: string = "";
  selectedUser: any = null;
  autocompleteKey: number = 0; // 用于强制重新创建组件
  searchMessage: string = ""; // 搜索提示信息

  // 搜索用户方法
  async searchUsers(queryString: string, callback: Function) {
    if (!queryString) {
      this.searchMessage = "";
      callback([]);
      return;
    }
    
    if (queryString.length < 3) {
      this.searchMessage = "请输入至少3位手机号码";
      callback([]);
      return;
    }
    
    // 如果当前输入的内容和已选择用户的显示文本相同，则不再搜索
    if (this.selectedUser && queryString === `${this.selectedUser.nickname} (${this.selectedUser.phone})`) {
      this.searchMessage = "";
      callback([]);
      return;
    }
    
    try {
      // 使用手机号搜索用户
      const res = await api_user.get_list({ 
        phone: queryString,
        page_size: 20 
      });
      
      if (res.results.length === 0) {
        this.searchMessage = "未找到匹配的用户";
        callback([]);
        return;
      }
      
      // 有结果时清除提示信息，让列表正常显示
      this.searchMessage = "";
      
      const suggestions = res.results.map((user: any) => ({
        value: `${user.nickname} (${user.phone})`,
        phone: user.phone,
        nickname: user.nickname,
        id: user.id,
        ...user
      }));
      
      callback(suggestions);
    } catch (error) {
      console.error('搜索用户失败:', error);
      this.searchMessage = "搜索失败，请重试";
      callback([]);
    }
  }

  // 处理输入事件
  handleUserInput(value: string) {
    // 限制最多输入11位
    if (value.length > 11) {
      this.userSearchText = value.substring(0, 11);
      return;
    }
    
    // 如果输入内容为空，清除选择和提示
    if (!value) {
      this.selectedUser = null;
      this.info.user = 1;
      this.searchMessage = "";
      return;
    }
    
    // 如果输入内容长度小于3，清除选择的用户但保留输入
    if (value.length < 3) {
      if (this.selectedUser) {
        this.selectedUser = null;
        this.info.user = 1;
      }
      return;
    }
    
    // 如果用户手动修改了输入内容，且不等于已选择用户的显示文本，则清除选择
    if (this.selectedUser && value !== `${this.selectedUser.nickname} (${this.selectedUser.phone})`) {
      this.selectedUser = null;
      this.info.user = 1;
    }
  }

  // 选择用户处理方法
  handleUserSelect(item: any) {
    this.selectedUser = item;
    this.info.user = item.id;
    this.userSearchText = `${item.nickname} (${item.phone})`;
    this.searchMessage = ""; // 清除提示信息
  }

  // 清除用户选择
  handleUserClear() {
    this.selectedUser = null;
    this.info.user = 1; // 重置为默认值
    this.userSearchText = "";
    this.searchMessage = ""; // 清除提示信息
    
    // 关键：通过改变 key 强制重新创建组件，这是最彻底的重置方法
    this.autocompleteKey += 1;
  }

  // 失去焦点时处理
  handleUserBlur() {
    // 如果输入框有内容但是没有选择用户，则清空输入框
    if (this.userSearchText && !this.selectedUser) {
      this.userSearchText = "";
      this.searchMessage = "";
    }
  }

  // 获取区域列表
  regionList:any[] = []
  async get_region_list(){
    const res = await api_region.get_list({page_size:10000})
    const list:any[] = [{label:'全部',value:''}]
    res.results.forEach((item:any)=>{
      item.value = item.id,
          item.label = item.name
    })
    this.regionList = list.concat(res.results)
  }

  created() {
    this.get_region_list();
    if (this.id === undefined) return;
    this.get_info();
  }
}
